<script lang="ts">
  import TagRenderingConfig from "../../../Models/ThemeConfig/TagRenderingConfig"
  import { Translation } from "../../i18n/Translation"
  import TagRenderingMapping from "./TagRenderingMapping.svelte"
  import type { SpecialVisualizationState } from "../../SpecialVisualization"
  import type { Feature } from "geojson"
  import { Store, UIEventSource } from "../../../Logic/UIEventSource"
  import LayerConfig from "../../../Models/ThemeConfig/LayerConfig"
  import { twMerge } from "tailwind-merge"
  import { onDestroy } from "svelte"
  import { Lists } from "../../../Utils/Lists"
  import Tr from "../../Base/Tr.svelte"

  export let tags: UIEventSource<Record<string, string> | undefined>

  export let state: SpecialVisualizationState
  export let selectedElement: Feature
  export let layer: LayerConfig
  export let config: TagRenderingConfig
  export let extraClasses: string | undefined = undefined
  export let defaultSize = "w-full"
  export let noIcons = false

  export let id: string = undefined

  if (config === undefined) {
    console.error("TagRenderingAnswer: Config is undefined")
    throw "Config is undefined in tagRenderingAnswer"
  }
  let trs: Store<{ then: Translation; icon?: string; iconClass?: string }[]> = tags.mapD(
    (tags) => Lists.noNull(config?.GetRenderValues(tags)),
    onDestroy
  )
</script>

{#if config !== undefined && (config?.condition === undefined || config.condition.matchesProperties($tags))}
  <div {id} class={twMerge("link-underline flex h-full  flex-col", defaultSize, extraClasses)}>
    {#if $trs.length === 1 && config.multiTitle === undefined}
      <TagRenderingMapping mapping={$trs[0]} {tags} {state} {selectedElement} {layer} {noIcons} />
    {:else}
      {#if config.multiTitle}
        <Tr t={config.multiTitle} />
      {/if}
      <ul>
        {#each $trs as mapping}
          <li>
            <TagRenderingMapping {mapping} {tags} {state} {selectedElement} {layer} {noIcons} />
          </li>
        {/each}
      </ul>
    {/if}
  </div>
{/if}
